export enum QuestionnaireUser {
    Viewer = 'VIEWER',
    External = 'EXTERNAL',
    Manager = 'MANAGER',
}
